import TaxStatementPDF from 'features/statementsAndForms/screens/TaxStatements/TaxStatementPdf';
import React from 'react';

export default function TaxStatementPdfPage() {
  return <TaxStatementPDF />;
}
